import { alertConfirm, alertConfirmDelete, alertError, alertSuccess, alertWarning } from "components/Alert"
import { initFileUploadData } from "constants/fileUploadConstant"
import { subcontractExpenseApiNm, subcontractInvoiceApiNm } from "constants/subcontractConstant"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import dayjs from "dayjs"
import { useEffect, useMemo } from "react"
import { useContext } from "react"
import { useCallback } from "react"
import { useState } from "react"
import { addIdForDataGrid, addNoDuplicate } from "utils"
import { initFilterData, initScInvData } from "./initData"
import { branchApiNm } from "branch/constant/branchApiNm"
import Swal from "sweetalert2"
import { UserContext } from "contexts/UserContext"
import { ACC_TYP_SUB } from "constants/accountConstant"
import { saveFile } from "components/FileUplaod/saveFile"
import { FOLDER_SUBCONTRACT_INVOICE_FILE } from "constants/serverConstant"

// let expenseData = []
let selectedExpId = 0
let selectedJOData = {}
// let lastFilter = null
// let lastGenDocnum = -1;
let jobOrdIds = []
let selectedRow = {}
let networkXpssDocNum = null
let oData = null
const useSubcontractExpenseDialog = ({ dialogOpen, onFinish, selectedId }) => {

  const [filterData, setFilterData] = useState(initFilterData)
  const [jobOrderTable, setJobOrdTable] = useState([])
  // const [expenseTable, setExpenseTable] = useState([])
  const [selectionModel, setSelectionModel] = useState([])
  const [dialogExpOpen, setDialogExpOpen] = useState(false)
  const [dialogAddExpenseTableOpen, setDialogAddExpenseTableOpen] = useState(false)
  const [scInvData, setScInvData] = useState(initScInvData)
  const [fileUploadData, setFileUploadData] = useState(initFileUploadData())
  const [dialogInvoiceSearchOpen, setDialogInvoiceSearchOpen] = useState(false)
  const [dialogMappingOpen, setDialogMappingOpen] = useState(false)
  const [dialogSearchOpen, setDialogSearchOpen] = useState(false)
  const [mappingData, setMappingData] = useState(null)
  const [isShowExpInInvoice, setIsShowExpInInvoice] = useState(true)
  const [anchorEl, setAnchorEl] = useState(null);
  const { user } = useContext(UserContext)
  const { ax, msData } = useContext(GlobalStateContext)

  const popOverOpen = Boolean(anchorEl);

  // const expenseTable = useMemo(()=>{

  // }, selectionModel, jobOrderTable)

  const expenseTable = useMemo(() => {
    const result = []
    const resultObj = {}
    const selectedRows = jobOrderTable.filter(row => selectionModel.includes(row.JobOrdId))
    let id = 0
    for (const jo of selectedRows) {
      for (const exp of jo.Exps) {
        if (isShowExpInInvoice && exp.ScInvId && exp.ScInvId !== selectedId) continue;

        const unqName = `${exp.ExpId}-${exp.UntPr}-${exp.VatPr}-${exp.WhtPr}-${exp.IsOwnRcpt}-${exp.ScInvId}`
        if (!resultObj[unqName]) {
          id++
          resultObj[unqName] = {
            ...exp,
            id: id,
            ScInvIds: exp.ScInvId ? [exp.ScInvId] : [],
            ScInvNos: exp.ScInvNo ? [exp.ScInvNo] : [],
            XpssDocNums: exp.XpssDocNum ? [exp.XpssDocNum] : [],
            ScExpIds: exp.ScExpId ? [exp.ScExpId] : [],
            Exps: [exp],
            Qty: +exp.Qty,
            Total: +exp.Total,
            WhtPr: +exp.WhtPr,
            VatPr: +exp.VatPr
          }
        } else {
          resultObj[unqName].Qty += +exp.Qty
          resultObj[unqName].Total += +exp.Total
          resultObj[unqName].WhtPr += +exp.WhtPr
          resultObj[unqName].VatPr += +exp.VatPr
          exp.ScInvId && !resultObj[unqName].ScInvIds.includes(exp.ScInvId) && resultObj[unqName].ScInvIds.push(exp.ScInvId)
          exp.ScInvNo && !resultObj[unqName].ScInvNos.includes(exp.ScInvNo) && resultObj[unqName].ScInvNos.push(exp.ScInvNo)
          exp.XpssDocNum && !resultObj[unqName].XpssDocNums.includes(exp.XpssDocNum) && resultObj[unqName].XpssDocNums.push(exp.XpssDocNum)
          exp.ScExpId && !resultObj[unqName].ScExpIds.includes(exp.ScExpId) && resultObj[unqName].ScExpIds.push(exp.ScExpId)
          resultObj[unqName].Exps.push(exp)
        }
      }
    }
    for (const key of Object.keys(resultObj)) {
      result.push(resultObj[key])
    }
    return result
  }, [jobOrderTable, selectionModel, isShowExpInInvoice, selectedId])

  const searchJobOrder = useCallback(() => {

    // if (filterData.ScId === null) {
    //   alertError("กรุณาระบุ รถร่วม")
    //   return
    // }
    const postData = {
      ...filterData,
    }
    ax.post(subcontractExpenseApiNm.getSubcontractExpenseJobOrder, postData).then(value => {
      if (value.data) {

        setJobOrdTable(o => {
          const result = [...o]
          const mergedData = addNoDuplicate(result, value.data.JobOrders, "JobOrdId")
          for (const row of mergedData) {
            const filtered = value.data.Expenses.filter(exp => exp.JobOrdId === row.JobOrdId)
            row.ScInvNo = filtered.length > 0 ? filtered.map(item => item.ScInvNo).join(", ") : ""
          }
          return addIdForDataGrid(mergedData, "JobOrdId")
        })
        // expenseData = value.data.Expenses
        // lastFilter = { ...filterData }

        if (value.data.JobOrders.length > 0) {
          const found = msData.subContractCombo.find(item => item.id === value.data.JobOrders[0].DrvId)

          setScInvData(o => ({
            ...o,
            ScId: found?.id
          }))

        }
      }
    })
  }, [ax, filterData, msData.subContractCombo])

  const handleSearchJobOrdIdChange = useCallback((e) => {
    if (e.keyCode === 13) {
      searchJobOrder({ JobOrdId: e.target.value || null })
    }
  }, [searchJobOrder])

  const calculateTotal = useCallback(() => {
    // const filteredExpense = expenseData.filter(item => selectionModel.includes(item.JobOrdId))

    let ownRcptAmnt = 0;
    let cusRcptAmnt = 0;
    let total = 0;
    let whtPr = 0;
    const filteredInv = expenseTable.filter(item => selectedId ? item.ScInvId === selectedId : item.ScInvId === null)
    filteredInv.forEach(exp => {
      if (exp.IsOwnRcpt) {
        ownRcptAmnt += +exp.Total
      } else {
        cusRcptAmnt += +exp.Total
      }
      total += +exp.Total
      whtPr += exp.IsOwnRcpt ? +exp.WhtPr : 0
    })
    setScInvData(o => ({
      ...o,
      OwnRcptAmnt: ownRcptAmnt,
      CusRcptAmnt: cusRcptAmnt,
      Total: total,
      WhtPr: whtPr,
      PayAmnt: total - whtPr
    }))
  }, [expenseTable, selectedId])

  // const calculateExpenseTable = useCallback((selectedJobOrdIds) => {
  //   const filteredExpense = expenseData.filter(item => selectedJobOrdIds.includes(item.JobOrdId))
  //   const groupByData = []
  //   filteredExpense.forEach(exp => {
  //     const found = groupByData.find(item => item.ExpId === exp.ExpId
  //       && item.UntPr === exp.UntPr
  //       && item.VatPr === exp.VatPr
  //       && item.WhtPr === exp.WhtPr
  //       && item.IsOwnRcpt === exp.IsOwnRcpt)
  //     if (found) {
  //       found.Qty += +exp.Qty
  //       found.Total += +exp.Total
  //     } else {
  //       groupByData.push({
  //         ...exp,
  //         Total: +exp.Total,
  //         Qty: +exp.Qty
  //       })
  //     }
  //   })
  //   setExpenseTable(addIdForDataGrid(groupByData, "ScExpId"))
  // }, [])

  const handleSelectionModelChange = useCallback((newSelectionModel) => {
    setSelectionModel(newSelectionModel)
    // calculateExpenseTable(newSelectionModel)
  }, [])

  const openExpDialog = useCallback((id) => {
    selectedExpId = id;
    setDialogExpOpen(true);
  }, [])

  const insertUpdateSubcontractExpense = useCallback((postdata) => {
    ax.post(subcontractExpenseApiNm.insertUpdateSubcontractExpenseBulk, postdata).then(value => {
      if (value.data) {
        // expenseData = value.data.Expenses
        setJobOrdTable(addIdForDataGrid(value.data, "JobOrdId"))
        // calculateExpenseTable(selectionModel)
        setDialogExpOpen(false)
        alertSuccess("เพิ่มรายได้เรียบร้อยแล้ว")
      }
    })
  }, [ax])

  const handleExpenseDialogOK = useCallback((dialogData) => {
    if (selectionModel.length === 0) {
      alertError("กรุณาเลือกอย่างน้อย 1 ใบงาน")
      return
    }

    const joData = jobOrderTable.find(item => item.JobOrdId === selectionModel[0])
    const scId = joData?.Scids ? jobOrderTable.find(item => item.JobOrdId === selectionModel[0]).ScIds.split(",")[0] : null
    dialogData.WhtPrct = +dialogData.WhtPrct
    delete dialogData.WhtPr
    dialogData.UntPr = +dialogData.UntPr
    dialogData.Qty = +dialogData.Qty
    let jsonData = { argsArr: [] }
    jsonData.getArgs = { JobOrdIds: jobOrderTable.map(row => row.JobOrdId) }
    jsonData.argsArr = selectionModel.map(id => ({
      ...dialogData,
      JobOrdId: id,
      ScId: scId
    }))
    insertUpdateSubcontractExpense(jsonData)
  }, [insertUpdateSubcontractExpense, selectionModel, jobOrderTable])

  const handleDeleteExpenseRow = useCallback((row) => {

    const msg = `ต้องการลบ ${row.ExpNm}${selectionModel.length > 1 ? ` จำนวน ${row.Qty} ใบงาน` : ``}หรือไม่`

    alertConfirmDelete(msg, () => {
      const found = expenseTable.find(item => item.id === row.id)
      console.log("found", found)
      if (found.ScInvIds.length > 0) {
        alertError("ไม่สามารถลบรายการที่มีการบันทึกใบแจ้งหนี้แล้วได้")
        return
      }
      const scExpIds = found.ScExpIds

      ax.post(subcontractExpenseApiNm.deleteSubcontractExpense, {
        ScExpIds: scExpIds, getArgs: { JobOrdIds: jobOrderTable.map(row => row.JobOrdId) }
      }).then(value => {
        if (value.data) {
          setJobOrdTable(addIdForDataGrid(value.data, "JobOrdId"))
          // expenseData = value.data.Expenses
          // calculateExpenseTable(selectionModel)
        }
      })
    })
  }, [ax, jobOrderTable, expenseTable, selectionModel])

  const getSubcontractExpenseJobData = useCallback(() => {
    const selectedData = jobOrderTable.filter(item => selectionModel.includes(item.JobOrdId))
    if (selectedData.length === 0) {
      alertError("กรุณาเลือกใบงานก่อน")
      return
    }
    if (scInvData.ScId === null) {
      alertError("กรุณาระบุเลือกรถร่วมก่อน")
      return
    }
    const jobIds = selectedData.map(item => item.JobId)

    const scId = scInvData.ScId

    ax.post(subcontractExpenseApiNm.getSubcontractExpenseJob, { JobIds: jobIds, ScIds: [scId] }).then(value => {
      if (value.data) {

        const checkAndPushData = (jobOrdId, data, expsData, jobOrdData) => {




          if ((data.ContSize && data.ContSize !== jobOrdData.ContSize)
            || (data.ContTyp && data.ContTyp !== jobOrdData.ContTyp)
            || (data.TlrTypId && data.TlrTypId !== jobOrdData.TlrTypId)) return;


          expsData.push({
            ScExpId: null,
            ScId: scId,
            JobOrdId: jobOrdId,
            ExpId: data.ExpId,
            VatPrct: data.VatPrct,
            WhtPrct: data.WhtPrct,
            UntPr: +data.UntPr,
            Qty: 1,
            IsOwnRcpt: data.IsOwnRcpt,
            Rmk: ""
          })
        }
        
        const expsData = []
        for (const jobOrdId of selectionModel) {
          const jobOrdData = selectedData.find(item => item.JobOrdId === jobOrdId)
          // for (const data of value.data.Expenses) {
          //   if (data.ExpId === 1) continue

          //   if (expsData.find(item => item.ExpId === data.ExpId && item.JobOrdId === jobOrdData.JobOrdId)) continue;

          //   checkAndPushData(jobOrdId, data, expsData, jobOrdData)
          // }

          for (const data of value.data.ScJobs) {

            if (expsData.find(item => item.ExpId === 1 && item.JobOrdId === jobOrdData.JobOrdId)) continue;


            if (data.JobId !== jobOrdData.JobId || data.ScId !== scId) continue;


            data.ExpId = 1
            data.VatPrct = 0
            data.WhtPrct = 1
            data.IsOwnRcpt = 1
            checkAndPushData(jobOrdId, data, expsData, jobOrdData)
          }
        }

        if (expsData.length === 0) {
          alertWarning(`ไม่พบรายการที่บันทึกไว้ กรุณาเพิ่มรายการใน "4.6 รถร่วม-งาน" ก่อน`)
          return
        }

        insertUpdateSubcontractExpense({ argsArr: expsData, getArgs: { JobOrdIds: jobOrderTable.map(row => row.JobOrdId) } })
      }
    })
  }, [ax, jobOrderTable, selectionModel, insertUpdateSubcontractExpense, scInvData.ScId])

  const insertSubcontractInvoiceWithExpense = useCallback(async () => {

    if (user.AccTypId === ACC_TYP_SUB) {
      scInvData.ScId = user.AccId
    }
    if (!scInvData.ScId) {
      alertError("กรุณาเลือกรถร่วมก่อน")
      return
    }
    const scExpIds = []
    for (const exps of expenseTable) {
      for (const exp of exps.Exps) {
        if (!exp.ScInvId) {
          scExpIds.push(exp.ScExpId)
        }
      }
    }
    if (scExpIds.length === 0) {
      alertError("ไม่พบรายได้ กรุณาเพิ่มรายได้ก่อน")
      return
    }
    const postData = {
      ...scInvData,
      XpssDocNum: scInvData.XpssDocNum === '' ? null : scInvData.XpssDocNum,
      ScExpIds: scExpIds
    }

    if (selectedId === 0) {
      // Insert new invoice
      ax.post(subcontractInvoiceApiNm.insertSubcontractInvoiceWithExpense, postData).then(async value => {
        if (value.data) {
          const scInvId = value.data
          await saveFile({
            ax,
            alertWarning,
            fileUploadData,
            setFileUploadData,
            apiUpdateFileName: subcontractInvoiceApiNm.updateFileName,
            apiDeleteFile: subcontractInvoiceApiNm.deleteFile,
            apiAddFile: subcontractInvoiceApiNm.uploadFile,
            key: "ScInvFileId",
            refKey: "ScInvId",
            refValue: scInvId
          })
          onFinish()
        }
      })
    } else {
      // Update existing invoice - just save files
      await saveFile({
        ax,
        alertWarning,
        fileUploadData,
        setFileUploadData,
        apiUpdateFileName: subcontractInvoiceApiNm.updateFileName,
        apiDeleteFile: subcontractInvoiceApiNm.deleteFile,
        apiAddFile: subcontractInvoiceApiNm.uploadFile,
        key: "ScInvFileId",
        refKey: "ScInvId",
        refValue: selectedId
      })
      onFinish()
    }
  }, [scInvData, expenseTable, ax, onFinish, user.AccId, user.AccTypId, selectedId, fileUploadData, setFileUploadData])

  // const updateXpssDocNum = useCallback(() => {
  //   if(!scInvData.XpssDocNum || !scInvData.XpssDocDte){
  //     alertError("กรุณาระบุเลขที่เอกสารและวันที่เอกสาร")
  //     return
  //   }  
  //   const postData = {
  //     ScInvId: selectedId,
  //     ColValues: {
  //       XpssDocNum: scInvData.XpssDocNum,
  //       XpssDocDte: dayjs(scInvData.XpssDocDte).format("YYYY-MM-DD")
  //     },
  //     logRmk: "แก้ไข เลขที่เอกสาร และวันที่เอกสาร Express"
  //   }
  //   ax.post(subcontractInvoiceApiNm.updateSubcontractInvoiceColumn, postData).then(value=>{
  //     if(value.data){
  //       alertSuccess("บันทึ่กเรียบร้อยแล้ว")
  //       onFinish()
  //     }
  //   })
  // }, [ax, onFinish, scInvData, selectedId])

  const updateSubcontractInvoice = useCallback(async () => {
    const colValue = {}
    let hasChange = false
    if (scInvData.XpssDocNum && oData.XpssDocNum !== scInvData.XpssDocNum) {
      hasChange = true
      colValue.XpssDocNum = scInvData.XpssDocNum
    }
    if (scInvData.XpssDocDte 
        && dayjs(oData.XpssDocDte).format("YYYY-MM-DD") !== dayjs(scInvData.XpssDocDte).format("YYYY-MM-DD")) {
      hasChange = true
      colValue.XpssDocDte = scInvData.XpssDocDte.format("YYYY-MM-DD")
    }
    if (oData.Rmk !== scInvData.Rmk) {
      hasChange = true
      colValue.Rmk = scInvData.Rmk
    }
    if (hasChange) {
      const postData = {
        ScInvId: selectedId,
        ColValues: colValue,
        logRmk: "แก้ไข ใบแจ้งหนี้รถร่วม"
      }
      await ax.post(subcontractInvoiceApiNm.updateSubcontractInvoiceColumn, postData)
    }

    await saveFile({
      ax,
      alertWarning,
      fileUploadData,
      setFileUploadData,
      apiUpdateFileName: subcontractInvoiceApiNm.updateFileName,
      apiDeleteFile: subcontractInvoiceApiNm.deleteFile,
      apiAddFile: subcontractInvoiceApiNm.uploadFile,
      key: "ScInvFileId",
      refKey: "ScInvId",
      refValue: selectedId
    })
    onFinish()
  }, [ax, onFinish, scInvData, selectedId, fileUploadData])

  const updateRemark = useCallback(() => {
    ax.post(subcontractInvoiceApiNm.updateSubcontractInvoiceRmk, { ScInvId: selectedId, Rmk: scInvData.Rmk }).then(value => {
      if (value.data) {
        alertSuccess("บันทึกหมายเหตุเรียบร้อยแล้ว")
        return
      }
    })
  }, [ax, scInvData.Rmk, selectedId])

  const deleteSubcontractInvoice = useCallback(() => {
    // alertConfirmDelete(() => {
    //   ax.post(subcontractInvoiceApiNm.deleteSubcontractInvoice, { ScInvId: selectedId }).then(value => {
    //     if (value.data) {
    //       onFinish()
    //     }
    //   })
    // })

    Swal.fire({
      text: "ต้องการลบค่าใช้จ่ายใน ใบแจ้งหนี้รถร่วม นี้ด้วยหรือไม่",
      icon: 'question',
      showDenyButton: true,
      denyButtonText: `ลบเฉพาะใบแจ้งหนี้`,
      confirmButtonText: 'ลบใบแจ้งหนี้และค่าใช้จ่าย',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#9c27b0',
      cancelButtonColor: '#d33',
    }).then((result) => {
      let postData = null
      if (result.isConfirmed) {
        postData = { ScInvId: selectedId, WithExpense: 1 }
      } else if (result.isDenied) {
        postData = { ScInvId: selectedId }
      }
      if (postData) {
        ax.post(subcontractInvoiceApiNm.deleteSubcontractInvoice, postData).then(value => {
          if (value.data) {
            onFinish()
          }
        })
      }
    })


  }, [ax, selectedId, onFinish])

  const handleClearFilter = useCallback(() => {
    setFilterData(initFilterData)
  }, [])

  const handleClearJobOrdTable = useCallback(() => {
    setJobOrdTable([])
    setSelectionModel([])
  }, [])

  const handleShowLinkExpense = useCallback(() => {
    if (!filterData.ScId) {
      alertError("กรุณาเลือกรถร่วมก่อน")
      return
    }

    // Get existing mappings for this subcontract
    const postData = {
      ScId: filterData.ScId
    }

    ax.post(subcontractExpenseApiNm.getExpenseMappings, postData).then(value => {
      if (value.data) {
        const { existingMappings, availableExpenses, sourceSiteAbbr } = value.data

        // Set mapping data to show existing mappings only (no unmapped expenses)
        setMappingData({
          existingMappings: existingMappings,
          unmappedExpenses: [], // Empty since we're just viewing existing mappings
          availableExpenses: availableExpenses,
          sourceSiteAbbr: sourceSiteAbbr,
          invoice: null // Not needed for viewing mappings
        })
        setDialogMappingOpen(true)
      }
    }).catch(err => {
      console.error("Error fetching expense mappings:", err)
      alertError(err.response?.data?.message || "เกิดข้อผิดพลาดในการดึงข้อมูลการแมป")
    })
  }, [ax, filterData.ScId])

  const handleChangeIsXpss = useCallback((e) => {
    const isXpssValue = e.target.checked ? 1 : 0
    ax.post(subcontractInvoiceApiNm.updateSubcontractInvoiceColumn, { ScInvId: selectedId, LogRmk: "แก้ไข การลง Express", ColValues: { IsXpss: isXpssValue } }).then(value => {
      if (value.data) {
        setScInvData(o => ({ ...o, IsXpss: isXpssValue }))
        alertSuccess("แก้ไขการลง Express เรียบร้อยแล้ว")
      }
    })
  }, [ax, selectedId])

  const generateXpssDocNum = useCallback(() => {
    // if (selectionModel.length === 0) {
    //   alertWarning("กรุณาเลือกอย่างน้อย 1 ใบงาน")
    //   return;
    // }

    // const jobOrder = jobOrderTable.find(item => item.JobOrdId === selectionModel[0])
    // if (!jobOrder) {
    //   alertError("เกิดข้อผิดพลาด")
    //   return
    // }
    // const scIds = jobOrder.ScIds.split(",")

    //Was thinking about 2 or more subcontract in one job next generate can hit second subcontract 
    // let  curGenDocNum = lastGenDocnum + 1
    // if(lastGenDocnum >= scIds.length ){
    //   curGenDocNum = 0
    // }


    ax.post(branchApiNm.generateScInvXpssDocNum, { ScId: scInvData.ScId }).then(value => {
      if (value.data) {
        setScInvData(o => ({ ...o, XpssDocNum: value.data }))
        // lastGenDocnum = curGenDocNum
      }
    })

  }, [ax, scInvData.ScId])

  const handleCellClick = useCallback(({ id, field, row }, e) => {
    if (field === "Remove") {
      setJobOrdTable(o => o.filter(r => r.id !== id))
    } else if (field === "ShowDetail") {

    } else if (field === "RcptNm") {
      e.stopPropagation();
      setAnchorEl(e.currentTarget);
      selectedRow = row
    }
  }, [])


  const handleAddExpnse = useCallback(() => {
    if (selectionModel.length === 0) {
      alert("กรุณาเลือกใบงาน")
      return
    }
    selectedJOData = jobOrderTable.find(jo => jo.JobOrdId === selectionModel[0])

    openExpDialog(0)
  }, [selectionModel, jobOrderTable, openExpDialog])

  const handleOpenAddExpTableDialog = useCallback(() => {

    if (selectionModel.length === 0) {
      alertError("กรุณาเลือกใบงานก่อน")
      return
    }
    selectedJOData = jobOrderTable.find(row => row.id === selectionModel[0])
    jobOrdIds = selectionModel
    setDialogAddExpenseTableOpen(true)
  }, [selectionModel, jobOrderTable])

  const onAddExpenseTableDialgoFinish = useCallback((data) => {
    if (selectionModel.length === 0) {
      alertError("กรุณาเลือกอย่างน้อย 1 ใบงาน")
      return
    }


    const argsArr = []
    for (const id of selectionModel) {
      for (const row of data) {
        argsArr.push({ JobOrdId: id, ...row })
      }
    }
    let jsonData = { argsArr: [] }
    jsonData.getArgs = { JobOrdIds: jobOrderTable.map(row => row.JobOrdId) }
    jsonData.argsArr = argsArr
    insertUpdateSubcontractExpense(jsonData)

  }, [selectionModel, insertUpdateSubcontractExpense, jobOrderTable])

  const handleOpenDialogInvoiceSearch = useCallback(() => {
    if (!filterData.ScId) {
      alertError("กรุณาเลือกรถร่วมก่อน")
      return
    }
    setDialogInvoiceSearchOpen(true)
  }, [filterData.ScId])

  const onInvoiceSearchDialogFinish = useCallback((data) => {
    if (data) {
      const postData = {
        ScId: filterData.ScId,
        InvNo: data.searchType === "InvNo" ? data.searchValue : null,
        BNNo: data.searchType === "BNNo" ? data.searchValue : null
      }
      ax.post(subcontractExpenseApiNm.insertLinkSubcontractInvoice, postData).then(value => {
        if (value.data) {
          const result = value.data
          const { invoice, expenses, unmappedExpenses, sourceSiteAbbr } = result

          console.log("Fetched invoice data:", result)

          // Check if there are unmapped expenses
          if (unmappedExpenses && unmappedExpenses.length > 0) {
            // Show mapping dialog instead of error
            setMappingData({
              ...result,
              originalSearchData: data // Store the original search data
            })
            setDialogMappingOpen(true)
            return
          }

          const importableExpenses = expenses.filter(exp => exp.canImport)

          if (importableExpenses.length === 0) {
            alertError("ไม่พบรายการค่าใช้จ่ายที่สามารถนำเข้าได้")
            return
          }

          // Show summary of what will be imported
          let summaryMsg = `พบใบแจ้งหนี้: ${invoice.InvNo}\n`
          summaryMsg += `วันที่: ${new Date(invoice.InvDte).toLocaleDateString('th-TH')}\n`
          summaryMsg += `ยอดรวม: ${invoice.Total?.toLocaleString()} บาท\n\n`
          summaryMsg += `รายการค่าใช้จ่ายที่จะนำเข้า (${importableExpenses.length} รายการ):\n`

          importableExpenses.forEach((exp, index) => {
            summaryMsg += `${index + 1}. ${exp.ExpNm} - ${exp.Total?.toLocaleString()} บาท\n`
          })

          summaryMsg += `\nจากระบบ: ${sourceSiteAbbr}`

          // Show confirmation dialog before importing
          summaryMsg += `\n\nต้องการนำเข้าข้อมูลเหล่านี้หรือไม่?`

          alertConfirm(summaryMsg, () => {
            // Call import API
            ax.post(subcontractExpenseApiNm.importSubcontractExpenses, postData).then(importResult => {
              if (importResult.data) {
                // Update the job order table and expense table with imported data
                const JobOrders = importResult.data

                if (JobOrders && JobOrders.length > 0) {
                  // Replace table with returned data instead of merging
                  // for (const row of JobOrders) {
                  //   const filtered = Expenses.filter(exp => exp.JobOrdId === row.JobOrdId)
                  //   row.ScInvNo = filtered.length > 0 ? filtered.map(item => item.ScInvNo || "").join(", ") : ""
                  // }

                  setJobOrdTable(addIdForDataGrid(JobOrders, "JobOrdId"))

                  // Replace expense data with returned data
                  // expenseData = Expenses

                  // Auto-select the imported job orders
                  const importedJobOrdIds = JobOrders.map(jo => jo.JobOrdId)
                  setSelectionModel(importedJobOrdIds)
                  // calculateExpenseTable(importedJobOrdIds)
                  setScInvData(o => ({
                    ...o,
                    ScId: filterData.ScId,
                    ScInvNo: data.searchType === "BNNo" ? data.searchValue : invoice.InvNo,
                    ScInvDte: data.searchType === "BNNo" ? dayjs(invoice.BNDte).format("YYYY-MM-DD") : dayjs(invoice.InvDte).format("YYYY-MM-DD"),
                  }))
                  alertSuccess(`นำเข้าข้อมูลสำเร็จ ${importableExpenses.length} รายการ`)
                } else {
                  alertSuccess("นำเข้าข้อมูลสำเร็จ")
                }
              }
            }).catch(importErr => {
              console.error("Error importing expenses:", importErr)
              alertError(importErr.response?.data?.message || "เกิดข้อผิดพลาดในการนำเข้าข้อมูล")
            })
          })

        }
      }).catch(err => {
        console.error("Error fetching invoice data:", err)
        alertError(err.response?.data?.message || "เกิดข้อผิดพลาดในการดึงข้อมูล")
      })
    }
  }, [ax, filterData.ScId])

  const handleSaveMapping = useCallback((mappingList) => {
    const postData = {
      sourceSiteAbbr: mappingData.sourceSiteAbbr,
      mappings: mappingList
    }

    ax.post(subcontractExpenseApiNm.saveExpenseMapping, postData).then(value => {
      if (value.data) {
        alertSuccess(value.data.message)
        setDialogMappingOpen(false)

        // Re-fetch the invoice data to get updated mapping
        const originalPostData = {
          ScId: filterData.ScId,
          InvNo: mappingData.originalSearchData?.searchType === "InvNo" ? mappingData.originalSearchData.searchValue : null,
          BNNo: mappingData.originalSearchData?.searchType === "BNNo" ? mappingData.originalSearchData.searchValue : null
        }

        ax.post(subcontractExpenseApiNm.insertLinkSubcontractInvoice, originalPostData).then(updatedValue => {
          if (updatedValue.data) {
            const updatedResult = updatedValue.data
            const { invoice, expenses, unmappedExpenses } = updatedResult

            if (unmappedExpenses && unmappedExpenses.length > 0) {
              // Still have unmapped expenses, show dialog again
              setMappingData(updatedResult)
              setDialogMappingOpen(true)
              return
            }

            // All mapped, proceed with import confirmation
            const importableExpenses = expenses.filter(exp => exp.canImport)

            if (importableExpenses.length > 0) {
              let summaryMsg = `พบใบแจ้งหนี้: ${invoice.InvNo}\n`
              summaryMsg += `วันที่: ${new Date(invoice.InvDte).toLocaleDateString('th-TH')}\n`
              summaryMsg += `ยอดรวม: ${invoice.Total?.toLocaleString()} บาท\n\n`
              // summaryMsg += `รายการค่าใช้จ่ายที่จะนำเข้า (${importableExpenses.length} รายการ):\n`

              // importableExpenses.forEach((exp, index) => {
              //   summaryMsg += `${index + 1}. ${exp.ExpNm} - ${exp.Total?.toLocaleString()} บาท\n`
              // })

              summaryMsg += `\nจากระบบ: ${updatedResult.sourceSiteAbbr}`
              summaryMsg += `\n\nต้องการนำเข้าข้อมูลเหล่านี้หรือไม่?`

              alertConfirm(summaryMsg, () => {
                // Import the expenses
                ax.post(subcontractExpenseApiNm.importSubcontractExpenses, originalPostData).then(importResult => {
                  if (importResult.data) {
                    const JobOrders = importResult.data

                    if (JobOrders && JobOrders.length > 0) {
                      // Replace table with returned data
                      // for (const row of JobOrders) {
                      //   const filtered = Expenses.filter(exp => exp.JobOrdId === row.JobOrdId)
                      //   row.ScInvNo = filtered.length > 0 ? filtered.map(item => item.ScInvNo || "").join(", ") : ""
                      // }

                      setJobOrdTable(addIdForDataGrid(JobOrders, "JobOrdId"))
                      // expenseData = Expenses

                      const importedJobOrdIds = JobOrders.map(jo => jo.JobOrdId)
                      setSelectionModel(importedJobOrdIds)
                      // calculateExpenseTable(importedJobOrdIds)
                      setScInvData(o => ({
                        ...o,
                        ScId: filterData.ScId,
                        ScInvNo: mappingData.originalSearchData?.searchType === "BNNo" ? mappingData.originalSearchData.searchValue : invoice.InvNo,
                        ScInvDte: mappingData.originalSearchData?.searchType === "BNNo" ? dayjs(invoice.BNDte).format("YYYY-MM-DD") : dayjs(invoice.InvDte).format("YYYY-MM-DD"),
                      }))

                      alertSuccess(`นำเข้าข้อมูลสำเร็จ ${importableExpenses.length} รายการ`)
                    }
                  }
                }).catch(importErr => {
                  alertError(importErr.response?.data?.message || "เกิดข้อผิดพลาดในการนำเข้าข้อมูล")
                })
              })
            }
          }
        })
      }
    }).catch(err => {
      alertError(err.response?.data?.message || "เกิดข้อผิดพลาดในการบันทึกการแมป")
    })
  }, [ax, mappingData, filterData.ScId])

  const handleRemoveMapping = useCallback((mappingRow) => {
    const message = `ต้องการลบการเชื่อมโยงระหว่าง "${mappingRow.sourceExpName}" และ "${mappingRow.currentExpName}" หรือไม่?`

    alertConfirmDelete(message, () => {
      const postData = {
        ScExpLnkId: mappingRow.ScExpLnkId,
        sourceSiteAbbr: mappingData.sourceSiteAbbr
      }

      ax.post(subcontractExpenseApiNm.removeExpenseMapping, postData).then(value => {
        if (value.data) {
          alertSuccess("ลบการเชื่อมโยงสำเร็จ")

          // Re-fetch mappings to update the display
          const fetchMappingsData = {
            ScId: filterData.ScId,
            sourceSiteAbbr: mappingData.sourceSiteAbbr
          }

          ax.post(subcontractExpenseApiNm.getExpenseMappings, fetchMappingsData).then(mappingsResult => {
            if (mappingsResult.data) {
              setMappingData(prev => ({
                ...prev,
                existingMappings: mappingsResult.data.existingMappings || []
              }))
            }
          })
        }
      }).catch(err => {
        alertError(err.response?.data?.message || "เกิดข้อผิดพลาดในการลบการเชื่อมโยง")
      })
    })
  }, [ax, mappingData, filterData.ScId])

  const handleOpenSearchDialog = useCallback(() => {
    setDialogSearchOpen(true)
  }, [])

  const handlePopOverClose = useCallback(() => {
    setAnchorEl(null);
  }, [])

  useEffect(() => {
    if (!selectedId) {
      if (jobOrderTable.length > 0) {
        for (const jo of jobOrderTable) {
          if (jo.IsSub) {
            setScInvData(o => ({
              ...o,
              ScId: jo.DrvId
            }))
            break
          }
        }
      }
    }
  }, [jobOrderTable, selectedId])

  useEffect(() => {
    if (dialogOpen) {
      if (selectedId > 0) {
        ax.post(subcontractInvoiceApiNm.getSubcontractInvoice, { ScInvId: selectedId }).then(value => {
          if (value.data && value.data.length > 0) {
            const invData = value.data[0]
            setScInvData(o => ({
              ...o,
              ...invData,
              ScInvDte: dayjs(invData.ScInvDte),
              XpssDocNum: invData.XpssDocNum || "",
            }))
            oData = { ...invData }
            networkXpssDocNum = invData.XpssDocNum
            setJobOrdTable(addIdForDataGrid(invData.JobOrders, "JobOrdId"))
            // expenseData = invData.Expenses
            const jobOrdIds = invData.JobOrders.map(item => item.JobOrdId)
            setSelectionModel(jobOrdIds)
            // calculateExpenseTable(jobOrdIds)

            // Load files
            const serverFiles = (invData.Files || []).map(item => ({
              id: item.ScInvFileId,
              fileNm: item.FileNm,
              scInvId: selectedId,
              label: item.Label,
              oLabel: item.Label,
              isEdit: false,
              file: null,
              imgLink: `${window.location.origin}/${FOLDER_SUBCONTRACT_INVOICE_FILE}${item.ScInvId}/${item.FileNm}`,
            }))
            setFileUploadData({ ...initFileUploadData(), serverFiles })
          }
        })
      } else {
        setFilterData(o => ({
          ...o,
          AptTmSt: dayjs(dayjs().format("YYYY-MM-DD 00:00:00.000")),
          AptTmEn: dayjs(dayjs().format("YYYY-MM-DD 23:59:59.997"))
        }))
      }
    } else {
      setJobOrdTable([])
      // setExpenseTable([])
      setSelectionModel([])
      setScInvData(initScInvData)
      setFilterData(initFilterData)
      setFileUploadData({ ...initFileUploadData() })
      oData = null
    }
  }, [dialogOpen, ax, selectedId])

  useEffect(() => {
    calculateTotal()
  }, [calculateTotal, expenseTable])
  console.log("InvData::", scInvData)
  return {
    state: {
      msData, filterData, jobOrderTable, expenseTable, selectionModel, dialogExpOpen, selectedExpId
      , scInvData, fileUploadData, dialogAddExpenseTableOpen, jobOrdIds, selectedJOData, dialogInvoiceSearchOpen
      , dialogMappingOpen, mappingData, dialogSearchOpen, isShowExpInInvoice, anchorEl, popOverOpen
      , selectedRow, networkXpssDocNum, oData
    },
    fn: {
      handleSearchJobOrdIdChange, searchJobOrder, setFilterData, handleSelectionModelChange, setDialogExpOpen
      , insertUpdateSubcontractExpense, handleDeleteExpenseRow, openExpDialog, getSubcontractExpenseJobData
      , handleExpenseDialogOK, setScInvData, setFileUploadData, insertSubcontractInvoiceWithExpense
      , updateRemark, deleteSubcontractInvoice, handleClearFilter, handleClearJobOrdTable, handleChangeIsXpss
      , generateXpssDocNum, setSelectionModel, handleCellClick, handleOpenAddExpTableDialog, setDialogAddExpenseTableOpen
      , onAddExpenseTableDialgoFinish, handleAddExpnse, setDialogInvoiceSearchOpen, onInvoiceSearchDialogFinish
      , handleOpenDialogInvoiceSearch, setDialogMappingOpen, handleSaveMapping, handleShowLinkExpense, handleRemoveMapping
      , handleOpenSearchDialog, setDialogSearchOpen, setJobOrdTable, setIsShowExpInInvoice
      , handlePopOverClose, updateSubcontractInvoice
    }
  }
}

export default useSubcontractExpenseDialog